import { FormattedMessage } from "react-intl"
import { styled, Typography } from "@mui/material"
import { IS_DEMO_SYSTEM, IS_SALES_SYSTEM, IS_TEC_DEMO_SYSTEM, IS_TEST_SYSTEM } from "~/constants/api"

interface InfoLabelProps {
  isAppBar: boolean
}

const StyledTypography = styled(Typography, { shouldForwardProp: prop => prop !== "isAppBar" })(
  ({ isAppBar }: { isAppBar: boolean }) => ({
    display: "flex",
    alignItems: "center",
    height: 64,
    color: "white",
    textTransform: "uppercase",
    padding: "0 15px",
    "@media screen and (max-width: 600px)": {
      label: {
        fontSize: 11,
        padding: "0 5px",
      },
    },
    ...(!isAppBar && {
      position: "absolute",
      top: 0,
      right: 20,
      "@media screen and (max-height: 500px)": {
        label: {
          height: 20,
        },
      },
    }),
  })
)

const getLabelKey = () => {
  if (IS_TEST_SYSTEM) {
    return "testSystem"
  }
  if (IS_DEMO_SYSTEM) {
    return "demoSystem"
  }
  if (IS_SALES_SYSTEM) {
    return "salesSystem"
  }
  if (IS_TEC_DEMO_SYSTEM) {
    return "tecDemoSystem"
  }
  return ""
}

const InfoLabel: React.FC<InfoLabelProps> = ({ isAppBar = false }) => {
  if (!IS_TEST_SYSTEM && !IS_DEMO_SYSTEM && !IS_SALES_SYSTEM && !IS_TEC_DEMO_SYSTEM) return null

  const labelKey = getLabelKey()
  const label = <FormattedMessage id={`app.appBar.${labelKey}`} />
  const variant = IS_TEST_SYSTEM || !isAppBar ? "h6" : "body1"

  return (
    <StyledTypography isAppBar={isAppBar} variant={variant}>
      {label}
    </StyledTypography>
  )
}

export default InfoLabel
